import { useEffect } from 'react'
import cn from 'clsx'
import localStorageManager from '@App/cookies/local_storage_manager'
import { useAppDispatch, useAppSelector } from '@App/hooks'
import { changeTheme, userState } from '@App/redux/slices/user/UserSlice'
import { DarkThemeIcon, LightThemeIcon } from '@App/static/icons/HeaderIcon'

import s from './ThemeSwitcher.module.scss'

export const ThemeSwitcher = () => {
  const dispatch = useAppDispatch()
  const { theme } = useAppSelector((state) => userState(state))

  useEffect(() => {
    document.documentElement.dataset.theme = theme === 'dark' ? 'dark' : 'light'
    localStorageManager.set('theme', theme === 'dark' ? 'dark' : 'light')
  }, [theme])

  return (
    <div
      className={s.mode}
      onClick={() => {
        dispatch(changeTheme())
      }}
    >
      <span className={cn(s.indicator, theme === 'dark' ? s.dark : s.light)} />
      <DarkThemeIcon className={cn(s.icon, s.dark, theme === 'dark' && s.active)} />
      <LightThemeIcon className={cn(s.icon, s.light, theme === 'light' && s.active)} />
    </div>
  )
}
